import FlexRow from "@/components/FlexRow.vue";
import ChevronUpIcon from "@/components/icons/ChevronUpIcon.vue";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronSelectorVerticalIcon from "@/components/icons/ChevronSelectorVerticalIcon.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
export default {
  name: "WrapWithArrow",
  components: {
    FlexRow,
    ChevronUpIcon,
    ChevronDownIcon,
    ChevronSelectorVerticalIcon,
    WrapWithPopover
  },
  props: {
    direction: {
      type: String
    },
    showNeutral: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    sortButtonDescription: {
      type: Object,
      default: () => ({
        detail: 'Sort by revenue'
      })
    }
  }
};